import React from "react";
import CustomModal from "../../common/CustomModal";
import CampaignsViewCard from "./CampaignsViewCard";

/** Read-only view of a track's campaigns per ad account, in rotation order. */
const CtmCampaignsViewModal = ({ ctm, onClose }) => {
  const accounts = ctm.campaign_accounts || [];

  return (
    <CustomModal
      open
      title={`Campaigns · ${ctm.track}`}
      onClose={onClose}
      isButtonsRequired={false}
      className="md:!w-[90%] lg:!w-[80%] xl:!w-[70%]"
      bodyClassName="py-4"
    >
      <div className="space-y-4">
        <p className="text-xs text-gray-500">
          {ctm.app_name} · {ctm.language || "—"} · {ctm.category || "—"} · Track
          #{ctm.track_number ?? "—"}. Auto launch uses these in order, one
          campaign per launch day, per ad account.
        </p>
        <div className="grid gap-3 sm:grid-cols-2">
          {accounts.map((a) => (
            <CampaignsViewCard key={a.meta_ad_account_id} account={a} />
          ))}
        </div>
      </div>
    </CustomModal>
  );
};

export default CtmCampaignsViewModal;
